import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    podcastMixin
} from './vue/mixins/podcast';
import lazyload from './features/lazy-load';

lazyload();
initMain([podcastMixin], {}, []);
header();